/**
 * Development environment settings
 *
 * This file is where you define overrides for any of the config settings when operating under the
 * development environment. Development environment is defined as `LORE_ENV=development` or the absence
 * of a `LORE_ENV` environment variable.
 */

export default {

  /**
   * To override a config setting, specify the name of the config file you
   * want to override, followed by the settings you want to change.
   */
  auth0: {
    clientID: 'zf5SMkng6DBUhaZSYwKNZs7spp4etmzZ', // LoginPreview SPA (staging tenant)
    redirectUri: 'http://localhost:5531/auth/callback',
  },
  connections: {
    default: {
      apiRoot: 'http://localhost:5519/community_v3'
    }
  },
  intercom: {
    // use ./scripts/view-intercom-logs.sh to see log locally
    messengerUrl: 'http://localhost:5569/messenger/web/messages',
    appId: 'localonly',
  }
}
